import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Props_SnippetAccordion } from './Accordion.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

export const SnippetAccordion = (props: Props_SnippetAccordion) => {
    const { heading, repeatable_entry } = props

    const [openItem, setOpenItem] = useState<number | null>(null)
    const toggleItem = (index: number) => {
        setOpenItem(currentIndex => currentIndex === index ? null : index)
    }
    const isItemOpen = (index: number) => openItem === index

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-accordion__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-accordion">
            <div className="snippet-accordion__container">
                <h2 className={`snippet-accordion__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                <div className="snippet-accordion__content">
                { repeatable_entry.map((accordion, index) => (
                    <div key={index} className="snippet-accordion__item">
                    <h3>
                        <button
                            className={`snippet-accordion__trigger ${isItemOpen(index) ? 'snippet-accordion__trigger--open' : ''}`}
                            onClick={() => toggleItem(index)}
                            aria-expanded={isItemOpen(index)}
                            aria-controls={`content-${index}`}
                        >
                            {accordion.heading?.value}
                        </button>
                    </h3>
                    <AnimatePresence>
                        { isItemOpen(index) && (
                        <motion.div
                            id={`content-${index}`}
                            className="snippet-accordion__item-content"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                        >
                            <div className="snippet-accordion__content-inner">
                                { accordion.content?.value && Legacy_CompileMarkdown(accordion.content?.value) }
                                { accordion.linkUrl?.value && accordion.linkContent?.value && (
                                    <a 
                                        href={accordion.linkUrl?.value}
                                        className="snippet-accordion__link"
                                        target={accordion.linkTarget?.value === 'true' ? '_blank' : '_self'}
                                        rel='noopener noreferrer'
                                    >
                                        {accordion.linkContent?.value}
                                    </a>
                                )}
                            </div>
                        </motion.div>
                        )}
                    </AnimatePresence>
                    </div>
                ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetAccordion